import axios from 'axios'
import { Message } from 'element-ui'

const miniAppRequest = axios.create({
  baseURL: '/api/admin/mini-app',
  timeout: 15000
})

let unauthorizedHandling = false

function handleUnauthorized(message = '登录已过期，请重新登录') {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  if (!unauthorizedHandling) {
    unauthorizedHandling = true
    Message.error(message)
    window.location.hash = '#/login'
    setTimeout(() => {
      unauthorizedHandling = false
    }, 2000)
  }
}

miniAppRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

miniAppRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        handleUnauthorized(res.message || '登录已过期，请重新登录')
      } else {
        Message.error(res.message || '请求失败')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      const data = error.response.data || {}
      handleUnauthorized(data.message || '登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

// 获取小程序列表
export function getMiniAppList(params) {
  return miniAppRequest({
    url: '/list',
    method: 'get',
    params
  })
}

// 获取小程序分页
export function getMiniAppPage(params) {
  return miniAppRequest({
    url: '/page',
    method: 'get',
    params
  })
}

// 获取小程序详情
export function getMiniAppById(id) {
  return miniAppRequest({
    url: '/' + id,
    method: 'get'
  })
}

// 创建小程序
export function createMiniApp(data) {
  return miniAppRequest({
    url: '',
    method: 'post',
    data
  })
}

// 更新小程序
export function updateMiniApp(id, data) {
  return miniAppRequest({
    url: '/' + id,
    method: 'put',
    data
  })
}

// 删除小程序
export function deleteMiniApp(id) {
  return miniAppRequest({
    url: '/' + id,
    method: 'delete'
  })
}
